const Url = {
  staticHost: process.env.STATIC_HOST,
  apiHost: process.env.API_HOST,
  socketHost: process.env.SOCKET_HOST,
  htApiHost: process.env.API_HOST?.replace('examapi', 'api'),
  wwwHost: process.env.API_HOST?.replace(/https:\/\/examapi01/, 'http://www.01')?.replace(
    /examapi/,
    'www',
  ),
  examCDN: process.env.EXAM_CDN,

  getMajorData: '/const/mixed-major', // 获取专业数据
  getColleges: '/common/const?type=college', // 获取高校常量
  getUserInfo: '/user/my-info', // 获取用户信息
  getUserResumes: '/resume/index', // 获取简历列表

  sts: '/sts/get-token', // sts 服务
  feedback: '/exam/feedback', // 反馈
  serverTime: '/monitor/time-table', // 服务器时间
  postFirstPicture: '/monitor/first-picture', // 提交首图
  postFrame: '/monitor/record-risk', // 提交帧
  fastPostFrame: '/monitor/fast-record-risk', //提交实时监控帧
  pertinent: '/answer/pertinent-moment', // 切题时刻
  byte: '/answer/byte', // 字节回放
  miniQrcode: '/common/mini-qrcode', // 生成小程序码
};
export default Url;
